var api_url = "http://192.168.2.10:3068/api/"
var socket_url = 'http://localhost:3068'
// api_url ="https://devapi.360inventory.app/api/"
var server = false;
const isProductionBuild = process.env.NODE_ENV === "production";

if (isProductionBuild) {
    server = true;
}


if (server) {
    api_url = "https://api.sipro.app/api/"
    socket_url = 'https://api.sipro.app'
}




export { api_url, socket_url };